"use strict";

define('controller/letter.template/list',['require','exports','module','underscore','../base','langs','../../view/page.list','../../view/table.ellipsis','../../view/empty.table','uikit/uikit','../../model/document','../../model/letter.template','../../model/template.type','../../model/sort','../../libs/route.helper','../../libs/format/date','../../config'],function (require, exports, module) {
  var _ = require('underscore');
  var RegionController = require('../base');
  var langs = require('langs');
  var PageListView = require('../../view/page.list');
  var TableEllipsis = require('../../view/table.ellipsis');
  var EmptyTableView = require('../../view/empty.table');
  var UIKit = require('uikit/uikit');
  var Document = require('../../model/document');
  var LetterTemplate = require('../../model/letter.template');
  var TemplateType = require('../../model/template.type');
  var Sort = require('../../model/sort');
  var RouteHelper = require('../../libs/route.helper');
  var dateFormatter = require('../../libs/format/date');
  var config = require('../../config');
  var CheckboxView = UIKit.Checkbox;
  var ButtonView = UIKit.Button;
  var p = langs.phrase;
  function generateLetterDetailLink(model) {
    return RouteHelper.createLink(model.isNew() ? 'letterTemplate:create' : 'letterTemplate:detail', model, {
      letterTemplateId: 'id'
    });
  }
  ;
  function navigateLetterDetail(model) {
    app.navigate(generateLetterDetailLink(model).slice(1), {
      trigger: true
    });
  }
  ;
  var LetterTemplateListController = RegionController.extend({
    header: p('App.Title'),
    authorities: ['PERM_VIEW_LETTERTEMPLATE'],
    onStart: function onStart() {
      var app = this.app,
        region = this.region,
        state = this.state;
      var root = new PageListView({
          search: false,
          sectionTitle: p('LetterTemplatesList.Title'),
          useTableHeader: true,
          hideTableHeaderFromScreens: true,
          tableHeaderText: 'List of Letter Templates'
        }),
        letterTemplates = LetterTemplate.all(),
        createLinkModel = new RouteHelper('letterTemplate:create'),
        templateTypes = TemplateType.all(Document.SUBMISSION),
        table = root.table;
      root.$el.css(config.contentCss);
      function childViewOptions() {
        return {
          toggle: true,
          polar: true,
          bindings: {
            value: 'active'
          }
        };
      }
      ;
      function setupRowActions(column) {
        return {
          collection: new Backbone.Collection([{
            text: 'Edit',
            icon: 'pencil',
            action: 'edit',
            link: generateLetterDetailLink(this.model)
          }, {
            text: 'Delete',
            icon: 'trash',
            action: 'destroy'
          }]),
          childBindings: {
            text: 'text',
            icon: 'icon',
            link: 'link'
          },
          ariaLabel: 'manage letter template'
        };
      }
      ;
      function onRowAction(row, child, actionModel) {
        var model = row.model;
        switch (actionModel.get('action')) {
          case 'edit':
            navigateLetterDetail(model);
            break;
          case 'destroy':
            app.request('modal', {
              type: 'CONFIRM_DESTROY',
              state: state,
              name: model.get('name'),
              entity: 'Letter Template'
            }, {
              ariaControlsId: row.cid
            }).on('destroy:model', function () {
              model.destroy({
                wait: true,
                animate: 'scale'
              });
            });
            break;
        }
      }
      ;
      function createNewTemplateButton() {
        return new ButtonView({
          text: p('LetterTemplateList.NewButton'),
          icon: 'plus',
          color: 'primary',
          link: createLinkModel.get('link')
        });
      }
      ;
      root.setupCollection(letterTemplates, {
        autoFetch: true
      }).setupSortDefaults({
        sort: 'name',
        sortDirection: Sort.ASCENDING
      }).addRightHeaderItem(createNewTemplateButton()).setupPaginate().setupPageSizes().setupTableSort().setupColumns([{
        text: 'Manage',
        useAccessibilityText: true,
        childView: TableEllipsis,
        collapsing: true,
        childViewOptions: setupRowActions
      }, {
        text: p('LetterTemplatesList.Column.Name'),
        data: 'name'
      }, {
        text: p('LetterTemplatesList.Column.Active'),
        childView: CheckboxView,
        childViewOptions: childViewOptions
      }, {
        text: p('LetterTemplatesList.Column.SubmissionType'),
        data: 'templateTypeDescription'
      }, {
        text: p('LetterTemplatesList.Column.LastModifiedDate'),
        data: 'activityDate',
        formatter: dateFormatter(config.dateFormat),
        collapsing: true
      }]);
      table.sortable = false;
      root.listenTo(letterTemplates, 'change:active', function (model, prev, options) {
        model.save();
      }).listenTo(table, 'row:double:press', function (row) {
        navigateLetterDetail(row.model);
      }).listenTo(table, 'row:before:add:child', function (row, child, model, column) {
        if (child instanceof TableEllipsis) {
          child.on('action', _.partial(onRowAction, row));
        }
      });
      table.selection = 'single';
      table.striped = false;
      table.selectable = true;
      state.addPageDependencies([letterTemplates, templateTypes]).on('page:loaded', function () {
        if (letterTemplates.length > 0) {
          region.show(root);
        } else {
          root.destroy();
          region.show(new EmptyTableView({
            button: createNewTemplateButton(),
            text: p('LetterTemplatesList.Empty'),
            headerTag: 'h1'
          }));
        }
      }).on('page:cancel', function () {
        root.destroy();
      });
      templateTypes.fetch();
      letterTemplates.fetch();
    }
  });
  module.exports = LetterTemplateListController;
});

